"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const toolkit_1 = require("@reduxjs/toolkit");
const app_types_1 = require("pages/app.types");
const area_types_1 = require("./area.types");
const initialState = {
    isLoading: true,
    isError: false,
    isSuccess: false,
    errorCode: 0,
    errorMessage: '',
    dataGrid: [],
    dataPit: [],
    mutationMode: false,
    dataItem: {
        id: '0',
        area_code: '',
        area_name: '',
        is_active: {
            value: true,
            status: 'Active'
        },
        modified_by: '',
        modified_date: new Date(),
        created_by: '',
        created_date: new Date(),
        description: '',
        pit_name: '',
        id_pit: '',
        pit: {
            id: '',
            pit: ''
        }
    },
    dataStates: {
        filterable: true,
        sortable: true,
        reorderable: false,
        scrollable: 'scrollable',
        skip: 0,
        take: 10,
        total: 0,
        sort: [{ field: 'modified_date', dir: 'desc' }]
    }
};
const areaReducer = (0, toolkit_1.createReducer)(initialState, {
    [app_types_1.appTypes.RESET_LOADING]: () => {
        return Object.assign({}, initialState);
    },
    [area_types_1.areaTypes.SET_DATA_GRID]: (state, action) => {
        const { dataGrid, count } = action.payload;
        return Object.assign(Object.assign({}, state), { dataGrid, isLoading: false, dataStates: Object.assign(Object.assign({}, state.dataStates), { total: count }) });
    },
    [area_types_1.areaTypes.ON_PAGE_CHANGE]: (state, action) => {
        const { dataStates, dataGrid } = action.payload;
        return Object.assign(Object.assign({}, state), { dataStates,
            dataGrid, isLoading: false });
    },
    [area_types_1.areaTypes.ON_MUTATION_CLICK]: (state, action) => {
        const { dataItem, mutationMode, isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { mutationMode: mutationMode, dataItem: dataItem ? dataItem : initialState.dataItem, isSuccess: isSuccess ? isSuccess : initialState.isSuccess });
    },
    [area_types_1.areaTypes.ON_SAVE_DATAITEM]: (state, action) => {
        const { dataItem, isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { isSuccess, mutationMode: false, isLoading: true, dataItem, dataGrid: state.dataGrid.map(item => {
                if (item.id === dataItem.id)
                    return dataItem;
                return item;
            }) });
    },
    [area_types_1.areaTypes.ON_DELETE]: (state, action) => {
        const { dataItem, isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { isSuccess, mutationMode: false, dataItem: initialState.dataItem, dataGrid: state.dataGrid.filter(item => item.id !== (dataItem === null || dataItem === void 0 ? void 0 : dataItem.id)) });
    },
    [area_types_1.areaTypes.ON_FILTER_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStates: Object.assign(Object.assign({}, state.dataStates), { filter: action.payload, skip: initialState.dataStates.skip }) });
    },
    [area_types_1.areaTypes.ON_SORT_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStates: Object.assign(Object.assign({}, state.dataStates), { sort: action.payload }) });
    },
    [area_types_1.areaTypes.SET_ERROR]: (state, action) => {
        const { isError, errorCode, errorMessage } = action.payload;
        return Object.assign(Object.assign({}, state), { isError, errorCode, errorMessage, isLoading: false });
    },
    [area_types_1.areaTypes.SET_LOADING]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: action.payload });
    },
    [area_types_1.areaTypes.GET_DETAIL]: (state, action) => {
        const { dataPit } = action.payload;
        return Object.assign(Object.assign({}, state), { dataPit });
    },
});
exports.default = areaReducer;
